import React, { Fragment, useEffect, useState } from "react";
import { Box, Flex, Text } from "../../../assets/ui";
import {
  CheckBox,
  Field,
  Radio,
  Range
} from "../../../components/common/FormElements";
import Theme from "../../../assets/ui/theme";
import { FieldArray, Form, Formik, Field as FieldFormik } from "formik";
import { StyledButton } from "../../../components/common/Button";
import Uploader from "../../../components/common/Uploader";
import { postData } from "../../../api";
import { CloseIcon } from "../../../assets/icons";
import { ClipLoader } from "react-spinners";
import {
  ModalBody,
  StyledModal,
  SubtitleBlock,
  TitleGroup,
  CancelButton,
  CloseBtn,
  StyledSuccessModal,
  TitleBlock
} from "./ui";

const drugs = [
  "Alcohol",
  "Cannabis",
  "Cocaine",
  "Ketamine",
  "Pill’s",
  "MDMA",
  "Zanex",
  "LSD",
  "DMT",
  "All of them ",
  "None of them"
];
const money = ["25k", "50k", "100k", "200k"];

const ApplicationForm = ({ toggleModal, job }) => {
  const [cvPath, setCvPath] = useState("");
  const [userPhotoPath, setUserPhotoPath] = useState("");
  const [dataSent, setDataSent] = useState(false);
  const [sendingData, setSendingData] = useState(false);
  useEffect(() => {
    document.body.style.overflow = "hidden";
  }, []);

  useEffect(() => {
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const onKeyDown = keyEvent => {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      keyEvent.preventDefault();
    }
  };

  return (
    <StyledModal>
      {sendingData ? (
        <ClipLoader
          sizeUnit={"px"}
          size={140}
          color={Theme.colors.mainPink}
          loading={true}
        />
      ) : dataSent ? (
        <StyledSuccessModal>
          <Flex justifyContent="flex-end" width="100%">
            <CloseBtn onClick={() => toggleModal(false)}>
              <CloseIcon />
            </CloseBtn>
          </Flex>
          <Text>Application sent</Text>

          <Text
            fontSize={["24px", null, "32px"]}
            lineHeight={["30px", null, "40px"]}
            fontWeight="bold"
            color="#233247"
            margin={["16px 0 32px", null, "35px 0 40px"]}
          >
            Thanks for applying!{" "}
          </Text>
          <Flex flexDirection="column" alignItems="center" maxWidth="280px">
            <Text fontWeight="bold">We can’t wait to read all about you!</Text>
            <Text margin={["24px 0 ", null, "35px 0 40px"]}>
              You will be notified with-in 24 hour if you made it to interview
              stage .
            </Text>
            <Text>
              Exsportia will take the world by storm and we hope you will be
              part of it
            </Text>
          </Flex>

          <StyledButton
            marginTop={["24px", null, "40px"]}
            width={["fit-content"]}
            onClick={() => toggleModal(false)}
          >
            Done
          </StyledButton>
        </StyledSuccessModal>
      ) : (
        <ModalBody>
          <Flex justifyContent={"space-between"}>
            <Text
              fontSize={["16px"]}
              lineHeight={["20px"]}
              fontWeight="bold"
              color={Theme.colors.mainPink}
            >
              {job.title}
            </Text>
            <CloseBtn onClick={() => toggleModal(false)}>
              <CloseIcon />
            </CloseBtn>
          </Flex>
          <Text
            fontSize={["16px"]}
            lineHeight={["20px"]}
            color={Theme.colors.darkBlue}
            marginBottom={["15px"]}
          >
            {job.prise}
          </Text>
          <Text
            fontSize={["24px"]}
            lineHeight={["30px"]}
            fontWeight="bold"
            color={Theme.colors.darkBlue}
            marginBottom={["24px"]}
          >
            {" "}
            Application form
          </Text>
          <Formik
            initialValues={{
              name: "",
              age: "",
              email: "",
              city: "",
              funnyJoke: "",
              dirtyJoke: "",
              smackSomeone: "",
              washHands1: "",
              washHands2: "",
              pickNose: "",
              eatIt: "",
              charmingRange: 5,

              stolenAnything: "",
              likedRange: 5,
              money: "25k",
              favoriteSport1: "",
              favoriteSport2: "",
              favoriteSport3: "",
              topFilm1: "",
              topFilm2: "",
              topFilm3: "",
              tvSeries1: "",
              tvSeries2: "",
              tvSeries3: "",
              experience: "",
              nightClub: "",
              DJ: "",
              festival: "",
              drugs: [],
              gender: "Man",

              relationship: "",
              facebook: "",
              instagram: "",
              linkedIn: "",
              drive: "",
              haveCar: "",
              likeTravel: ""
            }}
            validate={values => {}}
            onSubmit={async values => {
              setSendingData(true);
              const res = await postData("mailService/mails/work", {
                ...values,
                cvPath,
                role: job.title,
                userPhotoPath,
                workSalary: job.prise
              });
              setSendingData(false);
              setDataSent(true);
            }}
            render={({
              touched,
              errors,
              values,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue
            }) => (
              <Form onKeyDown={onKeyDown}>
                <TitleBlock>1. Personal information</TitleBlock>
                <Flex
                  flexDirection={["column", null, "row"]}
                  justifyContent={[null, null, "space-between"]}
                >
                  <Box marginRight={["0", null, "30px"]}>
                    <Field
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                      label="Your name"
                      placeholder="Full name..."
                    />
                    <Field
                      name="email"
                      value={values.email}
                      onChange={handleChange}
                      label="Your email"
                      placeholder="Email..."
                    />
                    <Field
                      name="age"
                      value={values.age}
                      onChange={handleChange}
                      label="Age"
                      placeholder="Select"
                      type="number"
                    />
                    <Field
                      name="city"
                      value={values.city}
                      onChange={handleChange}
                      label="Current City"
                      placeholder="For example: Bristol"
                    />
                    <TitleGroup>Gender</TitleGroup>
                    <Flex flexWrap="wrap" marginBottom="16px">
                      {["Man", "Woman"].map((el, index) => {
                        return (
                          <Radio
                            key={index}
                            value={el}
                            name="gender"
                            checked={values.gender === el}
                            setFieldValue={setFieldValue}
                          />
                        );
                      })}
                    </Flex>
                  </Box>
                  <Flex
                    flexDirection={["column", "row"]}
                    alignItems={["center", null, "flex-start"]}
                  >
                    <Box
                      marginRight={["0px", "15px"]}
                      marginBottom={["24px"]}
                      width={["230px", null, "220px"]}
                      minHeight="280px"
                    >
                      <Uploader
                        setFilePath={setCvPath}
                        acceptFiles=".pdf, .doc, .docx"
                        title="Attach CV"
                        description=".doc and .pdf should be fine"
                        filePath={cvPath}
                      />
                    </Box>
                    <Box
                      width={["230px", null, "220px"]}
                      minHeight="280px"
                      marginBottom={["24px"]}
                    >
                      <Uploader
                        setFilePath={setUserPhotoPath}
                        isRound
                        acceptFiles="image/jpeg, image/png"
                        title="Add your photo"
                        description=".jpeg or .pdf should be more than 500 kb or 300 dpi"
                        filePath={userPhotoPath}
                      />
                    </Box>
                  </Flex>
                </Flex>

                <TitleBlock>2. The questions</TitleBlock>
                <SubtitleBlock>
                  These questions may be a little strange but trust us , we know
                  who we want
                </SubtitleBlock>
                <Field
                  name="funnyJoke"
                  value={values.funnyJoke}
                  onChange={handleChange}
                  isTextarea
                  label="Tell us a funny joke"
                  placeholder="Your answer here..."
                />
                <Field
                  name="dirtyJoke"
                  value={values.dirtyJoke}
                  onChange={handleChange}
                  isTextarea
                  label="Tell us a dirty joke"
                  placeholder="Your answer here..."
                />
                <Field
                  name="smackSomeone"
                  value={values.smackSomeone}
                  onChange={handleChange}
                  isTextarea
                  label="If you could smack someone in the face who would it be and why"
                  placeholder="Your answer here..."
                />
                <Field
                  name="washHands1"
                  value={values.washHands1}
                  onChange={handleChange}
                  label="Do you wash you hands after a number 1 in the toilet"
                  placeholder="Your answer here..."
                />
                <Field
                  name="washHands2"
                  value={values.washHands2}
                  onChange={handleChange}
                  label="Do you wash you hands after a number 2 in the toilet"
                  placeholder="Your answer here..."
                />
                <Field
                  name="pickNose"
                  value={values.pickNose}
                  onChange={handleChange}
                  label="Do you pick you nose"
                  placeholder="Your answer here..."
                />
                <Field
                  label="Do you eat it"
                  name="eatIt"
                  value={values.eatIt}
                  onChange={handleChange}
                  placeholder="Your answer here..."
                />

                <Range
                  label="How charming are you  scale of 1 – 10"
                  name="charmingRange"
                  value={values.charmingRange}
                  onChange={handleChange}
                />
                <Field
                  name="stolenAnything"
                  value={values.stolenAnything}
                  onChange={handleChange}
                  isTextarea
                  label="Have you ever stolen anything if so what and did you get caught"
                  placeholder="Your answer here..."
                />
                <Range
                  label="How liked are you : scale  1 -10"
                  name="likedRange"
                  value={values.likedRange}
                  onChange={handleChange}
                />

                <TitleGroup>
                  How much money do you want to make next year:
                </TitleGroup>
                <Flex flexWrap="wrap" marginBottom="16px">
                  {money.map((el, index) => {
                    return (
                      <Radio
                        key={index}
                        value={el}
                        name="money"
                        checked={values.money === el}
                        setFieldValue={setFieldValue}
                      />
                    );
                  })}
                </Flex>

                <Field
                  name="favoriteSport1"
                  value={values.favoriteSport1}
                  onChange={handleChange}
                  label="What's your 3 favorite sports or activities"
                  placeholder="Answer 1"
                />
                <Field
                  name="favoriteSport2"
                  value={values.favoriteSport2}
                  onChange={handleChange}
                  placeholder="Answer 2"
                />
                <Field
                  name="favoriteSport3"
                  value={values.favoriteSport3}
                  onChange={handleChange}
                  placeholder="Answer 3"
                />

                <Field
                  name="topFilm1"
                  value={values.topFilm1}
                  onChange={handleChange}
                  label="Name your top 3 films"
                  placeholder="Answer 1"
                />
                <Field
                  name="topFilm2"
                  value={values.topFilm2}
                  onChange={handleChange}
                  placeholder="Answer 2"
                />
                <Field
                  name="topFilm3"
                  value={values.topFilm3}
                  onChange={handleChange}
                  placeholder="Answer 3"
                />

                <Field
                  name="tvSeries1"
                  value={values.tvSeries1}
                  onChange={handleChange}
                  label="Top 3 tv series"
                  placeholder="Answer 1"
                />
                <Field
                  name="tvSeries2"
                  value={values.tvSeries2}
                  onChange={handleChange}
                  placeholder="Answer 2"
                />
                <Field
                  name="tvSeries3"
                  value={values.tvSeries3}
                  onChange={handleChange}
                  placeholder="Answer 3"
                />

                <Field
                  name="experience"
                  value={values.experience}
                  onChange={handleChange}
                  isTextarea
                  label="No experience necessary but if you have any in sales please tell us ."
                  placeholder="Your answer here..."
                />
                <Field
                  name="nightClub"
                  value={values.nightClub}
                  onChange={handleChange}
                  label="What’s you favorite night club / bar"
                  placeholder="Your answer here..."
                />
                <Field
                  name="DJ"
                  value={values.DJ}
                  onChange={handleChange}
                  label="Favorite DJ"
                  placeholder="Your answer here..."
                />
                <Field
                  name="festival"
                  value={values.festival}
                  onChange={handleChange}
                  label="Favorite festival"
                  placeholder="Your answer here..."
                />

                <TitleGroup>
                  What's your favorite drug (don’t lie.) Check boxes :{" "}
                </TitleGroup>
                <Flex flexWrap="wrap">
                  <FieldArray
                    name="drugs"
                    render={arrayHelpers => (
                      <Fragment>
                        {drugs.map((drug, index) => {
                          return (
                            <FieldFormik
                              key={`${drug}_${index}`}
                              name={drug}
                              render={({ field }) => {
                                return (
                                  <CheckBox
                                    {...field}
                                    id={`${drug}_${index}`}
                                    name={drug}
                                    label={drug}
                                    arrayHelpers={arrayHelpers}
                                  />
                                );
                              }}
                            />
                          );
                        })}
                      </Fragment>
                    )}
                  />
                </Flex>

                <Field
                  name="relationship"
                  value={values.relationship}
                  onChange={handleChange}
                  isTextarea
                  label="Are you in a relationship"
                  placeholder="Your answer here..."
                />
                <Field
                  name="facebook"
                  value={values.facebook}
                  onChange={handleChange}
                  label="Facebook url"
                  placeholder="Your answer here..."
                />
                <Field
                  name="instagram"
                  value={values.instagram}
                  onChange={handleChange}
                  label="Instagram url (optional)"
                  placeholder="Your answer here..."
                />
                <Field
                  name="linkedIn"
                  value={values.linkedIn}
                  onChange={handleChange}
                  label="LinkedIn url (optional)"
                  placeholder="Your answer here..."
                />
                <Field
                  name="drive"
                  value={values.drive}
                  onChange={handleChange}
                  label="Do you drive?"
                  placeholder="Your answer here..."
                />
                <Field
                  name="haveCar"
                  value={values.haveCar}
                  onChange={handleChange}
                  label="Do you have a car?"
                  placeholder="Your answer here..."
                />
                <Field
                  name="likeTravel"
                  value={values.likeTravel}
                  onChange={handleChange}
                  label="Do you like to travel ?"
                  placeholder="Your answer here..."
                />
                <Flex
                  flexDirection={["column", null, "row-reverse"]}
                  justifyContent={[null, null, "flex-start"]}
                  marginTop={[null, null, "30px"]}
                >
                  <StyledButton
                    marginBottom={["15px", null, 0]}
                    marginTop={["30px", null, 0]}
                    marginLeft={[null, null, "14px"]}
                    width={["100%", null, "fit-content"]}
                    onClick={handleSubmit}
                  >
                    Send application
                  </StyledButton>
                  <CancelButton
                    onClick={() => toggleModal(false)}
                    width={["100%", null, "fit-content"]}
                  >
                    Cancel
                  </CancelButton>
                </Flex>
              </Form>
            )}
          />
        </ModalBody>
      )}
    </StyledModal>
  );
};

export default ApplicationForm;
